<template>
  <div class="publish">
    <BlogNav></BlogNav>
    <div class="wrap">
      <h3>发布文章</h3>
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item label="标题" prop="title">
          <el-input v-model="ruleForm.title"></el-input>
        </el-form-item>
        <el-form-item label="标签" prop="tag">
          <el-select v-model="ruleForm.tagid" placeholder="请选择标签" @change="changeTag($event)">
            <el-option v-for="(item, index) in tagList" :key="index" :label="item.tag_name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="简介" prop="desc">
          <el-input type="textarea" v-model="ruleForm.desc"></el-input>
        </el-form-item>
        <el-form-item label="作者" prop="author">
          <el-input v-model="ruleForm.author"></el-input>
        </el-form-item>
        <el-form-item label="md文件路径" prop="fileurl">
          <el-input v-model="ruleForm.fileurl" placeholder="仅支持md文件,后续版本支持上传。（路径参考post_file/xx）"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm('ruleForm')">发布</el-button>
          <el-button @click="resetForm('ruleForm')">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import "element-ui/lib/theme-chalk/index.css";
import BlogNav from "@/components/BlogNav.vue";

export default {
  name: "publish",
  components: {
    BlogNav
  },
  data() {
    return {
        tagList: [],
      ruleForm: {
        title: "",
        tagid: "",
        tagText: '',
        desc: "",
        author: "",
        fileurl: ""
      },
      rules: {
        title: [
          { required: true, message: "请输入文章标题", trigger: "blur" },
          {
            min: 1,
            max: 128,
            message: "长度在 1 到 128 个字符",
            trigger: "blur"
          }
        ],
        tagid: [{ required: true, message: "请选择标签", trigger: "change" }],
        desc: [{ required: true, message: "请填写文章简介", trigger: "blur" }],
        author: [{ required: true, message: "请填写作者名", trigger: "blur" }],
        fileurl: [
          { required: true, message: "请填写文件路径", trigger: "blur" }
        ]
      }
    };
  },
  created () {
      this.$api.getTagList().then( res => {
          this.tagList = res
      });
  },
  methods: {
    changeTag($event) {
      console.log($event);
      this.tagList.forEach(res=>{
        if (res.id==$event)
          this.ruleForm.tagText = res.tag_name;
      })
    },
    submitForm(formName) {
      var that = this;
      this.$refs[formName].validate(valid => {
        if (valid) {
            this.$api.publishPost(this.ruleForm).then( res => {
                if (res.code == 200) {
                  that.$router.go(0);
                }
            });
        } else {
        //   console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    }
  }
};
</script>

<style lang="less">
body {
  background-color: #f0f0f0;
}
.publish {
  .wrap {
    width: 58rem;
    height: auto;
    background-color: #fff;
    margin: 1rem auto;
    padding: 1rem;
    overflow: hidden;
  }
}
@media screen and (max-width: 768px) {
  .publish {
    .wrap {
      width: 100%;
      padding: 0;
    }
  }
}
</style>